import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { HEATMAP_MONTH_LABELS } from './planUsageHeatmapData'

export function PlanUsageHeatmapMonthLabels() {
  return (
    <Stack direction="row" justifyContent="center" alignItems="flex-start" spacing={0.25} sx={{ width: '100%', px: 1, flexWrap: 'nowrap', gap: '2px' }}>
      {HEATMAP_MONTH_LABELS.map((m) => (
        <Typography key={m} sx={{ flex: '1 1 0', minWidth: 0, textAlign: 'center', fontSize: '12px', fontWeight: 510, lineHeight: '30px', color: 'rgba(63, 63, 63, 1)' }}>
          {m}
        </Typography>
      ))}
    </Stack>
  )
}
